module.exports = __webpack_public_path__ + "static/media/image-1200.85d1185a.webp";